import { t } from "@lingui/macro";
import { Eye, List, PaintBrushHousehold } from "@phosphor-icons/react";
import { cn } from "@stylingcv/utils";

export type MobileBuilderTab = "sections" | "preview" | "design";

/** Reserve space above fixed bottom nav (tab bar + safe area). */
export const MOBILE_BOTTOM_NAV_OFFSET =
  "calc(3.5rem + env(safe-area-inset-bottom, 0px))";

interface MobileBottomNavProps {
  activeTab: MobileBuilderTab;
  onTabChange: (tab: MobileBuilderTab) => void;
}

export const MobileBottomNav = ({ activeTab, onTabChange }: MobileBottomNavProps) => {
  const tabs = [
    { id: "sections" as const, Icon: List, label: t`Sections` },
    { id: "preview" as const, Icon: Eye, label: t`Preview` },
    { id: "design" as const, Icon: PaintBrushHousehold, label: t`Design` },
  ];

  return (
    <nav
      className="mobile-bottom-nav fixed inset-x-0 bottom-0 z-40 flex border-t border-black/[0.07] bg-white shadow-[0_-6px_24px_rgba(10,22,40,0.12)]"
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
    >
      {tabs.map(({ id, Icon, label }) => {
        const isActive = activeTab === id;
        return (
          <button
            key={id}
            onClick={() => onTabChange(id)}
            className={cn(
              "flex flex-1 flex-col items-center gap-0.5 pb-2 pt-1 text-[9px] font-medium transition-colors",
              isActive ? "text-[#268599]" : "text-[#aaa]",
            )}
          >
            <span
              className={cn(
                "mb-0.5 h-[2.5px] w-[18px] rounded-full",
                isActive ? "bg-[#268599]" : "bg-transparent",
              )}
            />
            <Icon size={20} weight={isActive ? "fill" : "regular"} />
            <span>{label}</span>
          </button>
        );
      })}
    </nav>
  );
};
